import { getChallengeAttempt, getScore } from "@dailywars/core/db";
import { challengeMapIdSchema } from "@dailywars/core/engine/types/inputSchemas";
import { createServerFn } from "@tanstack/react-start";
import * as z from "zod";

import { setRouteAction } from "#/lib/requestLogger.server";
import { gameContextMiddleware } from "#/server/game/gameContextMiddleware";

export const loadChallengeLeaderboardPlayGate = createServerFn({ method: "GET" })
  .middleware([gameContextMiddleware])
  .validator(z.object({ mapId: challengeMapIdSchema }).strict())
  .handler(async ({ data, context }) => {
    setRouteAction("challenge_leaderboard_play_gate");
    const { playerId } = context.gameContext;
    const [score, attempt] = await Promise.all([
      getScore(data.mapId, playerId),
      getChallengeAttempt({ playerId, mapId: data.mapId }),
    ]);
    return {
      hasPlayed: score !== null || attempt !== null,
    };
  });
